<script>
/** DEPRECATED 27th June 2021
 * The new Cropper is on Component FrameCropImageBoxTool and FrameCropper
 *
*/
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'NewCropImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'crop',
      title: 'Crop v1',
      showLocal: true,
      activeObject: null,
      block: true,

      // Crop helpers
      // pict: null,
      mask: null, // crop preview mask (1:1 with controls)
      maskhole: null, // hole in mask
      imgcopy: null, // image duplicate outside with alpha
      control: null, // Controls rect

      originalClipPath: null,

      limits: {
        scaleY: 1,
        scaleX: 1,
      },

      hotkey: 'alt+c',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  watch: {
    control(value) {
      console.log('this.control has changed', value);
    },
  },
  beforeDestroy() {
    this.canvas.uniScaleTransform = false;
    this.canvas.remove(this.el);
    this.removeCropElements();

    this.canvas.onHistory();
  },
  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.uniScaleTransform = true;

      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = this.canvas.getActiveObject().get('type') === 'image';
      } else {
        this.showLocal = false;
      }
    },
    action() {
      this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
      this.canvas.offHistory();
      this.$emit('changeMode', 'cropping');
      this.activeObject = this.canvas.getActiveObject();
      this.originalClipPath = this.activeObject.clipPath
        ? fabric.util.object.clone(this.activeObject.clipPath) : null;
      this.lockElements();
      this.addCropElements();
      this.canvas.on('object:moving', this.onMoving);
      this.canvas.on('before:transform', this.onBeforeTransform);
      this.canvas.on('object:scaling', this.onScaling);
      this.canvas.on('mouse:dblclick', (options) => {
        // Reset crop
        if (options.target.id === 'imgcopy') this.reset();
      });
      // this.canvas.on("object:rotating", this.onRotating);
      // this.canvas.on("mouse:up", (o) => {
      //     if (this.control !== null)
      //         this.canvas.setActiveObject(this.control)
      // });
    },
    onModified(e) {
      console.log(e);
      const obj = e.target;
      const rect = obj.getBoundingRect();

      const image = this.activeObject;
      console.log(rect);
      console.log('image.getBoundingRect()', image.getBoundingRect());
    },
    onBeforeTransform(targetObject) {
      if (targetObject.transform.target) {
        targetObject.transform.target.lockScalingX = false;
        targetObject.transform.target.lockScalingY = false;
      }
      return true;
    },
    onScaling(options) {
      if (options.target.id === 'control') {
        this.maskhole.set({
          left: this.control.left,
          top: this.control.top,
          width: this.control.width,
          height: this.control.height,
          scaleX: this.control.scaleX,
          scaleY: this.control.scaleY,
        });
        this.canvas.renderAll();
      } else if (options.target.id === 'imgcopy') {
        this.activeObject.set({
          left: this.imgcopy.left,
          top: this.imgcopy.top,
          height: this.imgcopy.height,
          width: this.imgcopy.width,
          scaleX: this.imgcopy.scaleX,
          scaleY: this.imgcopy.scaleY,
        });
        this.canvas.renderAll();
      }
    },
    onMoving(options) {
      if (options.target.id === 'control') {
        // Sync mask hole with control
        console.log('this.control', this.control);
        this.maskhole.set({
          left: this.control.left,
          top: this.control.top,
          width: this.control.width,
          height: this.control.height,
        });
        this.canvas.renderAll();
      } else if (options.target.id === 'imgcopy') {
        // Sync alpha image with actual image
        this.activeObject.set({
          left: options.target.left,
          top: options.target.top,
          width: options.target.width,
          height: options.target.height,
        });
        this.canvas.renderAll();
      }
    },
    /** Unused for now */
    onRotating(options) {
      if (options.target.id === 'imgcopy') {
        this.activeObject.set({
          left: options.target.left,
          top: options.target.top,
          angle: options.target.angle,
        });
      }
    },
    lockElements(active = true) {
      this.canvas.discardActiveObject();
      this.canvas.getObjects().forEach((e) => {
        e.selectable = e.id === 'imgcopy' ? true : !active;
      });
      this.canvas.renderAll();
    },
    addCropElements() {
      console.log('addCropElements');
      const { activeObject } = this;
      let controlBox = {
        left: activeObject.left,
        top: activeObject.top,
        width: activeObject.width * activeObject.scaleX,
        height: activeObject.height * activeObject.scaleY,
      };

      if (activeObject.clipPath) {
        const clip = activeObject.clipPath;
        let vector = { x: clip.left, y: clip.top };

        // translate to center
        // "center" images don't need translation.
        // if (activeObject.originX != 'center')
        // vector = this.vTranslate(vector, activeObject.width / 2, activeObject.height / 2);
        // scale
        vector = this.vScale(vector, activeObject.scaleX, activeObject.scaleY);
        // rotate
        // translate to position
        const xVector = (clip.width * clip.scaleX * activeObject.scaleX) / 2.0;
        const yVector = (clip.height * clip.scaleY * activeObject.scaleY) / 2.0;
        vector = this.vTranslate(vector, xVector, yVector);
        vector = this.vRotate(vector, activeObject.angle);

        vector = this.vTranslate(vector, activeObject.left, activeObject.top);

        controlBox = {
          // top: activeObject.top + (activeObject.height/2 + clip.top)*activeObject.scaleY,
          // left: activeObject.left + (activeObject.width/2 + clip.left)*activeObject.scaleX,
          left: vector.x,
          top: vector.y,
          width: clip.width * clip.scaleX * activeObject.scaleX,
          height: clip.height * clip.scaleY * activeObject.scaleY,
        };
      }

      // Create control
      console.log('this.control', this.control);
      this.control = new fabric.Rect({
        id: 'control',
        left: controlBox.left,
        top: controlBox.top,
        originX: activeObject.originX,
        originY: activeObject.originY,
        width: controlBox.width,
        height: controlBox.height,
        absolutePositioned: true,
        fill: false,
        stroke: '#333333',
        strokeWidth: 1,
        strokeUniform: true,
        hasRotatingPoint: false,
        cornerColor: '#333333',
        cornerStyle: 'square',
        cornerSize: 5,
        borderColor: '#111',
        transparentCorners: false,
        angle: activeObject.angle,
      });
      console.log('this.control 2', this.control);
      // Create mask
      this.maskhole = new fabric.Rect({
        left: this.control.left,
        top: this.control.top,
        originX: this.control.originX,
        originY: this.control.originY,
        width: this.control.width,
        height: this.control.height,
        inverted: true,
        absolutePositioned: true,
        angle: this.control.angle,
      });
      this.mask = new fabric.Rect({
        left: 0,
        top: 0,
        width: this.canvas.getWidth(),
        height: this.canvas.getHeight(),
        absolutePositioned: true,
        inverted: true,
        fill: false,
        clipPath: this.maskhole,
      });
      this.imgcopy = fabric.util.object.clone(activeObject);
      this.imgcopy.set({
        id: 'imgcopy',
        clipPath: undefined,
        opacity: 0.15,
        selectable: true,
        hasRotatingPoint: false,
      });
      activeObject.clipPath = this.mask;
      this.canvas.add(this.imgcopy);
      this.canvas.add(this.control);
      this.canvas.setActiveObject(this.control);
      this.canvas.renderAll();
    },
    removeCropElements() {
      this.canvas.remove(this.imgcopy);
      this.canvas.remove(this.control);
      this.canvas.remove(this.mask);
      this.imgcopy = null;
      this.control = null;
      this.mask = null;
    },
    complete() {
      this.docrop();
      this.$nextTick().then(() => {
        this.removeCropElements();
        this.$emit('changeMode', null);
        this.$emit('complete');
        this.lockElements(false);
        this.activeObject = null;
      });
    },
    cancel() {
      this.$emit('changeMode', null);
      this.removeCropElements();
      this.lockElements(false);
      if (this.activeObject) {
        this.activeObject.set({
          clipPath: this.originalClipPath,
        });
        this.activeObject = null;
        this.$emit('complete');
      }
      this.canvas.renderAll();
    },
    reset() {
      this.removeCropElements();
      this.activeObject.clipPath = undefined;
      this.addCropElements();
      this.canvas.renderAll();
      // this.$emit('complete');
    },
    docrop() {
      // Apply in reverse operations to align image frame with canvas frame

      let vector = { x: this.control.left, y: this.control.top };
      // translate to origin
      vector = this.vTranslate(vector, -this.activeObject.left, -this.activeObject.top);
      vector = this.vRotate(vector, -this.activeObject.angle);
      vector = this.vTranslate(vector,
        (-this.control.width * this.control.scaleX) / 2,
        (-this.control.height * this.control.scaleY) / 2);
      vector = this.vScale(vector, 1 / this.activeObject.scaleX, 1 / this.activeObject.scaleY);

      this.activeObject.set({
        clipPath: new fabric.Rect({
          // top: this.control.top/this.activeObject.scaleY - this.activeObject.height/2 - this.activeObject.top/this.activeObject.scaleY,
          // left: this.control.left/this.activeObject.scaleX - this.activeObject.width/2 - this.activeObject.left/this.activeObject.scaleX,
          left: vector.x,
          top: vector.y,
          width: this.control.width / this.activeObject.scaleX,
          height: this.control.height / this.activeObject.scaleY,
          scaleX: this.control.scaleX,
          scaleY: this.control.scaleY,
        }),
      });
      this.activeObject.dirty = true;
      this.activeObject.setCoords();
      this.canvas.renderAll();
    },
    // Vector operations
    vRotate({ x, y }, deg) {
      const rad = (deg * 3.14) / 180;
      return {
        x: x * Math.cos(rad) - y * Math.sin(rad),
        y: x * Math.sin(rad) + y * Math.cos(rad),
      };
    },
    vTranslate({ x, y }, tx, ty) {
      return { x: x + tx, y: y + ty };
    },
    vScale({ x, y }, sx, sy) {
      return { x: x * sx, y: y * sy };
    },
  },
};
</script>
